import React from 'react'

const RolesManagement = () => {
  return (
    <div>
      RolesManagement
    </div>
  )
}

export default RolesManagement
